import { ServiceBase } from '../../../../../core/services/ServiceBase'
import Proxy from './Proxy'

class Service extends ServiceBase {
  getPortfolioByOrgId(params) {
    return this.getData(() => Proxy.getPortfolioByOrgId(params))
  }

  addNewCompany(params) {
    return this.getData(() => Proxy.addNewCompany(params))
  }

  deleteCompany(params) {
    return this.getData(() => Proxy.deleteCompany(params))
  }

  postCreatePortfolio(params) {
    return this.getData(() => Proxy.postCreatePortfolio(params))
  }
}

export default new Service()
